import React from 'react'
import QdContainer from 'components/Common/QdContainer'
import { Provider } from './AddressMappingContext'
import JobList from './JobList'

function AddressMapping() {
    return (
        <Provider>
            <QdContainer>
                <JobList />
            </QdContainer>
        </Provider>
    )
}

export default AddressMapping
